/* ==========================================================================
   TNF · Rueckmeldung beim Merken
   --------------------------------------------------------------------------
   WOFUER:
   Halo speichert beim Klick aufs Herz still im Browser. Sichtbar passiert
   nichts ausser einer Farbaenderung am Symbol - und die uebersieht man,
   weil der Blick beim Klicken auf dem Finger liegt, nicht auf dem Herz.
   Der Kunde klickt dann ein zweites Mal und wirft das Teil damit wieder
   raus, ohne es zu merken.

   Deshalb: eine kurze Einblendung unten links. Sie sagt, was passiert ist,
   und bietet den Weg zur Liste an - der Kunde muss nicht raten, wo seine
   gemerkten Teile gelandet sind.

   WARUM MIT VERZOEGERUNG:
   Halo haengt die Klasse "wishlist-added" in seinem eigenen Klickgriff an.
   In welcher Reihenfolge die beiden Griffe laufen, haengt davon ab, welche
   Datei zuerst geladen wurde - darauf ist kein Verlass. 30 Millisekunden
   spaeter steht der Zustand fest, egal wer zuerst dran war.
   ========================================================================== */
(function () {
  'use strict';

  var ZIEL = '/pages/wish-list';
  var DAUER = 4000;
  var kasten = null;
  var uhr = null;

  function bauen() {
    if (kasten) return kasten;
    kasten = document.createElement('div');
    kasten.className = 'tnf-wl-toast';
    kasten.setAttribute('role', 'status');
    kasten.setAttribute('aria-live', 'polite');
    document.body.appendChild(kasten);
    return kasten;
  }

  function zeigen(text, mitLink) {
    var k = bauen();

    k.innerHTML =
      '<span class="tnf-wl-ico" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24"><path d="M12 20.5l-1.4-1.3C5.7 14.9 3 12.4 3 9.3 3 6.9 4.9 5 7.3 5c1.4 0 2.7.6 3.5 1.7L12 7.9l1.2-1.2C14 5.6 15.3 5 16.7 5 19.1 5 21 6.9 21 9.3c0 3.1-2.7 5.6-7.6 9.9L12 20.5z"/></svg>' +
      '</span>' +
      '<span class="tnf-wl-text">' + text + '</span>' +
      (mitLink ? '<a class="tnf-wl-link" href="' + ZIEL + '">Ansehen</a>' : '');

    /* Neu anstossen, damit die Einblendung auch beim zweiten Mal laeuft. */
    k.classList.remove('is-on');
    void k.offsetWidth;
    k.classList.add('is-on');

    clearTimeout(uhr);
    uhr = setTimeout(function () { k.classList.remove('is-on'); }, DAUER);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wishlist]') : null;
    if (!btn) return;

    setTimeout(function () {
      if (btn.classList.contains('wishlist-added')) {
        zeigen('Zur Wunschliste hinzugefügt', true);
      } else {
        zeigen('Von der Wunschliste entfernt', false);
      }
    }, 30);
  });

  /* Ein Klick auf die Einblendung schliesst sie - manche wollen sie weghaben,
     bevor die vier Sekunden um sind. Der Link darin bleibt davon unberuehrt. */
  document.addEventListener('click', function (e) {
    if (!kasten) return;
    if (e.target.closest('.tnf-wl-link')) return;
    if (e.target.closest('.tnf-wl-toast')) kasten.classList.remove('is-on');
  });
})();
